<script>
	export let firstName = '';
</script>

<header class="profile-header">
	<h1 class="profile-title">Profil</h1>
	<p class="profile-greeting">
		{#if firstName}Hej, {firstName}!{:else}Hej!{/if}
	</p>
</header>
